import { autocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import searchResultProps from "@store/theme/props/searchResult";

Object.assign(autocompleteContentStyles, {
    headerText: searchResultProps.title,
    link: searchResultProps.link,
    focusedLink: searchResultProps.linkFocus,
});
